export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_PERMISSION = 'SET_CURRENT_PERMISSION';
export const SET_NAVIGATION_CONFIRM = 'SET_NAVIGATION_CONFIRM';
export const REMOVE_NAVIGATION_CONFIRM = 'REMOVE_NAVIGATION_CONFIRM';

export const SET_FILTER_DROPDOWN_SHOW = 'SET_FILTER_DROPDOWN_SHOW';
export const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export const SET_FORM_CONTROL_SHOW = 'SET_FORM_CONTROL_SHOW';
export const RESET_FILTER = 'RESET_FILTER';

export const UPDATE_AUTH0_LOADING = 'UPDATE_AUTH0_LOADING';
export const UPDATE_AUTH0_USER = 'UPDATE_AUTH0_USER';
export const UPDATE_GET_ALL_TOKEN_LOADING = 'UPDATE_GET_ALL_TOKEN_LOADING';

export const UPDATE_TOKEN = 'UPDATE_TOKEN';

export const LOGOUT = 'LOGOUT';
